import * as BABYLON from "babylonjs";
import { CoordUtils } from "../../earth/core/coordUtils";
import { GeoPoint } from "../../earth/core/geoPoint";
import { FrameTime } from "../../earth/earthEngine";
import { EarthEngine } from "../../earth/earthEngine";
import { Country } from "../../earth/model/country";
import { Main } from "../main";
import { Brand } from "../model/brand";
import { MetricType } from "../model/metricType";
import { UIContext } from "./uiContext";
import { UIContextDetails } from "./uiContextDetails";
import { UIContextLoadingScreen } from "./uiContextLoadingScreen";
import { UIContextNavigation } from "./uiContextNavigation";

export class UIContextAttractMode extends UIContext {
    static readonly TransitionTime: number = 5.0;
    static readonly RotationSpeed: number = 0.01;
    static readonly RotationHeight: number = 1.8;
    static readonly RotationLattitude: number = 40.0;

    private _timer: number = 0;
    private _onScreenTouched: number = -1;

    enter(from: UIContext) {
        super.enter(from);

        if (from.constructor.name != UIContextLoadingScreen.name) {
            let position = EarthEngine.instance.camera.position;
            let geoPosition = CoordUtils.babylonToGeo(position);
            let newGeoPosition = new GeoPoint(UIContextAttractMode.RotationLattitude, geoPosition.longitude);
            EarthEngine.instance.camera.focusOnPosition(newGeoPosition, UIContextAttractMode.RotationHeight, UIContextAttractMode.TransitionTime);
            Main.instance.uiManager.setState({ selectedBrands: Brand.AllBrands });
            Main.instance.uiManager.setState({ selectedMetricType: MetricType.Engagement });
            Main.instance.uiManager.setState({ infoPanelVisible: false });
            Main.instance.uiManager.setState({ selectedCountry: null});
        } else  {
            this._timer = UIContextAttractMode.TransitionTime;
        }

        this._onScreenTouched = EarthEngine.instance.interactionManager.screenTouched.connect(() => { this.shouldSwitchToContext.emit(new UIContextNavigation()); });
    }

    leave(to: UIContext) {
        if (this._onScreenTouched >= 0) {
            EarthEngine.instance.interactionManager.screenTouched.disconnect(this._onScreenTouched);
            this._onScreenTouched = -1;
        }
        super.leave(to);
    }

    update(time: FrameTime) {
        super.update(time);
        this._timer += time.deltaTime;
        if (this._timer >= UIContextAttractMode.TransitionTime) {
            let currentPosition: BABYLON.Vector3  = EarthEngine.instance.camera.position;
            let matrix = BABYLON.Matrix.RotationAxis(BABYLON.Axis.Y, (Math.PI * 2) * time.deltaTime * UIContextAttractMode.RotationSpeed);
            let newPosition = BABYLON.Vector3.TransformCoordinates(currentPosition, matrix);
            EarthEngine.instance.camera.setPosition(newPosition);
        }
    }

    onEarthTapped(country: Country | null) {
        super.onEarthTapped(country);
        if (country) {
            this.shouldSwitchToContext.emit(new UIContextDetails(country));
        } else {
            this.shouldSwitchToContext.emit(new UIContextNavigation());
        }
    }

    onSkyTapped() {
        super.onSkyTapped();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/uiContextAttractMode.tsx